import { library, IconPack, IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { faExclamationTriangle, faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons';

// Add 'regular' icons to FontAwesome library
library.add(
	far as IconPack,
	faExclamationTriangle as IconDefinition,
	faArrowUpRightFromSquare as IconDefinition
);